import React, {useState} from 'react';
import * as PropTypes from 'prop-types';
import classnames from 'classnames';
import {NeuroMessage, PrintButton, ShareViaEmailModal, ShareViaSmsModal} from '../index.mjs';
import {useBreakpoints} from '../../neuro-ui/index.mjs';

const SocialActionBar = (
  {
    className,
    customIcons,
    showIconText,
    useEmail = true,
    usePrint = true,
    useStackedLayout,
    useTextMessage = true
  }) => {
  const componentClass = 'socialActionBar';
  const { lg: screenIsLarge } = useBreakpoints();
  const [showTextMsg, setShowTextMsg] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const classes = classnames(className, componentClass, {
    [`${componentClass}--noText`]: !showIconText,
    [`${componentClass}--stacked`]:  useStackedLayout || !screenIsLarge
  });
  const isDetailsPage = window.location.href.indexOf('details') > -1;

  return (
    <div className={classes}>
      <label><NeuroMessage id={`${componentClass}.title`} /></label>
      { useTextMessage &&  <button className={`${componentClass}__button`} onClick={() => setShowTextMsg(true)}>
        { customIcons?.textMessageIcon ? (customIcons.textMessageIcon) : <i className="fa fa-comments-o" /> }
        { showIconText && <NeuroMessage id={`${componentClass}.textMessage`} tagName='span' /> }
      </button> }
      { useEmail && <button className={`${componentClass}__button`} onClick={() => setShowEmail(true)}>
        { customIcons?.emailIcon ? (customIcons.emailIcon) : <i className="fa fa-envelope-o" /> }
        { showIconText && <NeuroMessage id={`${componentClass}.email`} tagName='span' /> }
      </button> }
      { usePrint && <PrintButton className={`${componentClass}__button`} shouldOpenDetailsPage={!isDetailsPage}>
        { customIcons?.printIcon ? (customIcons.printIcon) : <i className="fa fa-print" /> }
        { showIconText && <NeuroMessage id={`${componentClass}.print`} tagName='span' /> }
      </PrintButton> }

      { useTextMessage && <ShareViaSmsModal isOpen={showTextMsg} onClose={() => setShowTextMsg(false)} /> }
      { useEmail && <ShareViaEmailModal isOpen={showEmail} onClose={() => setShowEmail(false)} /> }
    </div>
  );
};

SocialActionBar.propTypes = {
  className: PropTypes.string,
  customIcons: PropTypes.object,
  showIconText: PropTypes.bool,
  useEmail: PropTypes.bool,
  usePrint: PropTypes.bool,
  useStackedLayout: PropTypes.bool,
  useTextMessage: PropTypes.bool
};

export default SocialActionBar;
